export default __webpack_public_path__ + "static/media/beep.77435b6d.wav";